import { Component, EventEmitter,Output } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
     <div class="card-footer">
      <button type="button" class="btn btn-warning" (click)="salvarModificacoesCombustivel(false)">
        <i class="fa fa-eraser" aria-hidden="true"></i>&nbsp;&nbsp;Cancelar
      </button>

      <button type="button" class="btn btn-primary" (click)="salvarModificacoesCombustivel(true)">
        <i class="fa fa-save" aria-hidden="true"></i>&nbsp;&nbsp;Salvar
      </button>
    </div>
  `,
  styles: [
  ]
})
export class FooterComponent {
  @Output() salvarModificacoes = new EventEmitter<boolean>();
  salvarModificacoesCombustivel(param: boolean) {
    this.salvarModificacoes.emit(param);
  }

}
